module.exports = ".commands{\n\tpadding-top: 15px;\n}\n\n.commands>div{\n\tpadding: 0px;\n}\n"